module.exports = __webpack_public_path__ + "static/bullywug-dfb6b511a66ba7e0202cd3fbe78e9f58.jpg";